import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import ResponseBarChart from './ResponseBarChart';
import { PositiveMoodChart, NegativeMoodChart } from './ResponseLineCharts';
//eslint-disable-next-line
import { FaUser, FaCalendarAlt, FaClock, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../css/ParticipantInfoPage.css';
import api from '../utils/axiosConfig';

function ParticipantInfoPage() {
  // eslint-disable-next-line no-unused-vars
  const [user, setUser] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [sessionInfo, setSessionInfo] = useState(null);
  //const [chartView, setChartView] = useState('barrieren');

  const loadParticipantData = async (participant) => {
    try {
      const response = await api.get(`/api/responses/${participant.code}`);
      setResponses(response.data);

      if (response.data.length > 0) {
        const parseSession = (session) => {
          const parts = session.session_id.split('_');
          return { date: parts[1], hour: parts[2]?.split('-')[0] }; 
        };

        const first = parseSession(response.data[0]);
        const last = parseSession(response.data[response.data.length - 1]);

        setSessionInfo({
          date: first.date,
          hour: first.hour,
          lastDate: last.date,
          lastHour: last.hour,
        });
      }
    } catch (error) {
      console.error('Fehler beim Laden der Antworten:', error);
      setError('Fehler beim Laden der Antworten.');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setError('Nicht authentifiziert.');
        setLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(token);
        const userId = decoded._id;

        const userRes = await api.get(`/api/users/${userId}`);

        const userData = userRes.data;
        setUser(userData);

        const participantsRes = await api.get(`/api/participants`);

        const codePrefix = userData.code.slice(0, 5);
        const relatedParticipants = participantsRes.data.filter(p =>
          p.code.startsWith(codePrefix)
        );

        setParticipants(relatedParticipants);
        if (relatedParticipants.length > 0) {
          await loadParticipantData(relatedParticipants[0]);
        }
      } catch (err) {
        console.error('Fehler beim Laden:', err);
        setError('Fehler beim Laden der Informationen.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const currentParticipant = participants[selectedIndex];

  const handleNext = () => {
    const nextIndex = (selectedIndex + 1) % participants.length;
    setSelectedIndex(nextIndex);
    loadParticipantData(participants[nextIndex]);
  };

  const handlePrevious = () => {
    const prevIndex = (selectedIndex - 1 + participants.length) % participants.length;
    setSelectedIndex(prevIndex);
    loadParticipantData(participants[prevIndex]);
  };

  const formatShortDate = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}.${month}.${year.slice(2)}`;
  };


  /* if (loading) return <p>Lade Daten...</p>;
  if (error) return <p>{error}</p>; */

  if (loading) return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Lade Daten...</p>
    </div>
  );
  
  if (error) return (
    <div className="error-container">
      <div className="error-icon">!</div>
      <p>{error}</p>
    </div>
  );

  return (
    <div className="participant-info-page">
      <div className="info-header">
        <button className="arrow-button" onClick={handlePrevious} disabled={participants.length < 2}>
          <FaChevronLeft />
        </button>

        <div className="info-box">
          <FaUser className="icon" />
          <div>
            <div className="label">Name</div>
            <div className="value participant-name">
              {currentParticipant?.name}
            </div>
            <select
              className="participant-dropdown"
              value={currentParticipant?._id}
              onChange={(e) => {
                const selectedId = e.target.value;
                const index = participants.findIndex(p => p._id === selectedId);
                if (index !== -1) {
                  setSelectedIndex(index);
                  loadParticipantData(participants[index]);
                }
              }}
            >
              {participants.map((p) => (
                <option key={p._id} value={p._id}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="info-box">
          <FaCalendarAlt className="icon" />
          <div>
            <div className="label">Studienzeitraum</div>
            <div className="value">
              {/* {sessionInfo && `${sessionInfo.date?.split('-').reverse().join('.')} - ${sessionInfo.lastDate?.split('-').reverse().join('.')}`} */}
              {sessionInfo && `${formatShortDate(sessionInfo.date)} - ${formatShortDate(sessionInfo.lastDate)}`}
            </div>
          </div>
        </div>

        {/* <div className="info-box">
          <FaClock className="icon" />
          <div>
            <div className="label">Zeitfenster</div>
            <div className="value">
              {sessionInfo && `${sessionInfo.hour}:00 - ${parseInt(sessionInfo.hour) + 1}:00 Uhr`}
            </div>
          </div>
        </div> */}

        <button className="arrow-button" onClick={handleNext} disabled={participants.length < 2}>
          <FaChevronRight />
        </button>
      </div>
      
      <div className="chart-section">
        <ResponseBarChart responses={responses} />

        <PositiveMoodChart responses={responses} />

        <NegativeMoodChart responses={responses} />
      </div> 

      {/* <div className="chart-section">
        <select
          className="chart-select"
          value={chartView}
          onChange={(e) => setChartView(e.target.value)}
        >
          <option value="barrieren">Barrieren</option>
          <option value="stimmung">Stimmung</option>
        </select>

        {chartView === 'barrieren' && <ResponseBarChart responses={responses} />}
        {chartView === 'stimmung' && (
          <>
            <PositiveMoodChart responses={responses} />
            <NegativeMoodChart responses={responses} />
          </>
        )}
      </div> */}
    </div>
  );
}

export default ParticipantInfoPage;
